import { render } from "./payrollreportsalaryslip.vue?vue&type=template&id=44581306"
import script from "./payrollreportsalaryslip.vue?vue&type=script&lang=js"
export * from "./payrollreportsalaryslip.vue?vue&type=script&lang=js"

import "./payrollreportsalaryslip.vue?vue&type=style&index=0&id=44581306&lang=css"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__